import store from '@/store/index.js'

let dic = store.state.dic;

import { isIdCardNo } from "@/libs/checker.js";
import { validateCardId, getBirthdayByIdNO, getSexByIdNO, validatePhone, } from "@/libs/elementChecker"

export default function Configs(that) {

    const searchItems = [
        {
            label: '工号',
            span: 6,
            model: 'teacherId'
        },
        {
            label: '姓名',
            span: 6,
            model: 'name',
        },
        // {
        //     label: '联系电话',
        //     span: 6,
        //     model: 'phoneNumber',
        // },
    ]
    const tableColumns = [
        {
            label: '工号',
            prop: 'teacherId',
            align: 'center',
            show: true,
            minWidth: 160,
        },
        {
            label: '姓名',
            prop: 'name',
            align: 'center',
            show: true
        },
        {
            label: '性别',
            prop: 'sexName',
            align: 'center',
            show: true,
        }, {
            label: '家庭住址',
            prop: 'addressInfo',
            align: 'center',
            show: true,
            minWidth: 300,
        },
        {
            label: '联系电话',
            prop: 'phoneNumber',
            align: 'center',
            show: true,
            minWidth: 140,
        },
        {
            label: '操作',
            name: 'contr',
            align: 'center',
            width: '200px',
            show: true
        }
    ]

    const formItems = [
        {
            label: '工号',
            span: 24,
            model: 'teacherId',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '姓名',
            span: 24,
            model: 'name',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '证件类型',
            span: 24,
            model: 'idCardType',
            type: 'select',
            options: dic._CARDTYPE,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '身份证号',
            span: 24,
            model: 'idCard',
            labelClass: 'info-label',
            labelWidth: '150px',
            change(idCardNo) {
                // console.log(idCardNo)
                if (isIdCardNo(idCardNo)) {
                    that.handleData.dateBirth = getBirthdayByIdNO(idCardNo)
                    that.handleData.sex = getSexByIdNO(idCardNo)
                } else {
                    that.handleData.dateBirth = "";
                    that.handleData.sex = "";
                }
            }
        },
        {
            label: '出生日期',
            span: 24,
            model: 'dateBirth',
            // type: 'date',
            labelClass: 'info-label',
            labelWidth: '150px',
            disabled: true,
        },
        {
            label: '性别',
            span: 24,
            model: 'sex',
            type: 'select',
            options: dic._SEXS,
            placeholder: "",
            labelClass: 'info-label',
            labelWidth: '150px',
            disabled: true,
        },
        {
            label: '联系电话',
            span: 24,
            model: 'phoneNumber',
            labelClass: 'info-label',
            labelWidth: '150px',
        },

        {
            label: '政治面貌',
            span: 24,
            model: 'politicalCode',
            type: 'select',
            options: dic._POLITICAL,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '婚姻状况',
            span: 24,
            model: 'marriageStatus',
            type: 'select',
            options: dic._HYZK,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '民族',
            span: 24,
            model: 'nationCode',
            type: 'select',
            options: dic._NATION,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        // {
        //     label: '家庭住址编码',
        //     span: 24,
        //     model: 'addressAreaCode',
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        {
            label: '详细家庭住址',
            span: 24,
            model: 'addressInfo',
            labelClass: 'info-label',
            labelWidth: '150px',
        }
    ]

    const formRules = {
        teacherId: [{
            required: true,
            trigger: 'blur',
            message: '请输入工号',
        }],
        name: [{
            required: true,
            trigger: 'blur',
            message: '请输入姓名',
        }],
        addressInfo: [{
            required: true,
            trigger: 'blur',
            message: '请输入详细家庭住址',
        }],
        idCard: [{
            required: true,
            validator: validateCardId,
            trigger: "blur"
        }],
        phoneNumber: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
        }],
    }

    const gridItems = [
        {
            label: '工号',
            span: 24,
            model: 'teacherId',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '姓名',
            span: 24,
            model: 'name',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '证件类型',
            span: 24,
            model: 'idCardTypeName',
            type: 'select',
            options: dic._CARDTYPE,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '身份证号',
            span: 24,
            model: 'idCard',
            labelClass: 'info-label',
            labelWidth: '150px',
            change(idCardNo) {
                // console.log(idCardNo)
                if (isIdCardNo(idCardNo)) {
                    that.handleData.dateBirth = getBirthdayByIdNO(idCardNo)
                    that.handleData.sex = getSexByIdNO(idCardNo)
                } else {
                    that.handleData.dateBirth = "";
                    that.handleData.sex = "";
                }
            }
        },
        {
            label: '出生日期',
            span: 24,
            model: 'dateBirth',
            // type: 'date',
            labelClass: 'info-label',
            labelWidth: '150px',
            disabled: true,
        },
        {
            label: '性别',
            span: 24,
            model: 'sexName',
            type: 'select',
            options: dic._SEXS,
            placeholder: "",
            labelClass: 'info-label',
            labelWidth: '150px',
            disabled: true,
        },
        {
            label: '联系电话',
            span: 24,
            model: 'phoneNumber',
            labelClass: 'info-label',
            labelWidth: '150px',
        },

        {
            label: '政治面貌',
            span: 24,
            model: 'politicalName',
            type: 'select',
            options: dic._POLITICAL,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '婚姻状况',
            span: 24,
            model: 'marriageStatusName',
            type: 'select',
            options: dic._HYZK,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '民族',
            span: 24,
            model: 'nationName',
            type: 'select',
            options: dic._NATION,
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        // {
        //     label: '家庭住址编码',
        //     span: 24,
        //     model: 'addressAreaCode',
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        {
            label: '详细家庭住址',
            span: 24,
            model: 'addressInfo',
            labelClass: 'info-label',
            labelWidth: '150px',
        }
    ]
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules,
        gridItems
    }
}
